// extracted by mini-css-extract-plugin
module.exports = {"container":"orderDataSection_container__2wlvG"};